import { gql } from "graphql-request";

export const READ_ALL_COMPANIES = gql`
  query ReadAllCompanies {
    readAllCompanies {
      id
      legalName
      tradingName
      industry
      companySizeBand
      websiteURL
      linkedInURL
      phone
      email
      status
      primaryContactID
      activeTenantID
      createdAt
      updatedAt
      archivedAt
    }
  }
`;

export const READ_COMPANY_BY_ID = gql`
  query ReadCompanyByID($id: ID!) {
    readCompanyByID(id: $id) {
      id
      legalName
      tradingName
      industry
      companySizeBand
      websiteURL
      linkedInURL
      phone
      email
      status
      primaryContactID
      activeTenantID
      createdAt
      updatedAt
      archivedAt
    }
  }
`;